import { Box, Dialog } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  '& .RFBActionWrapper': {
    position: 'fixed',
    bottom: 0,
    left: 0,
    backgroundColor: theme.palette.secondary.main,
    backdropFilter: `blur(${theme.spacing(1)})`,
    padding: theme.spacing(1),
    width: '100%',
  },
}));

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    backgroundColor: theme.palette.background.secondary,
    backgroundImage: 'none',
  },
  '& .MuiDialogTitle-root': {
    padding: theme.spacing(6, 2, 4),
  },
  '& .MuiDialogContent-root': {
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
  },
  '& .RFBClose': {
    position: 'absolute',
    right: theme.spacing(2),
    top: 0,
    '& .MuiSvgIcon-root': {
      fontSize: theme.typography.pxToRem(18),
    },
  },
}));
export default StyledBox;
